
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexhyMXUmjJA7Meta } from "/opt/buildhome/repo/pages/admin/index.vue?macro=true";
import { default as usersHTuVCXEMNSMeta } from "/opt/buildhome/repo/pages/admin/merchants/[id]/users.vue?macro=true";
import { default as websiteKozLM7DwZVMeta } from "/opt/buildhome/repo/pages/admin/merchants/[id]/website.vue?macro=true";
import { default as settingsL7gywDGAzZMeta } from "/opt/buildhome/repo/pages/admin/settings.vue?macro=true";
import { default as _91id_93jAlrOh87hsMeta } from "/opt/buildhome/repo/pages/customers/[id].vue?macro=true";
import { default as indexVR98auG18ZMeta } from "/opt/buildhome/repo/pages/customers/index.vue?macro=true";
import { default as indexSEhdEZkNMjMeta } from "/opt/buildhome/repo/pages/dashboard/index.vue?macro=true";
import { default as indexniDiYCWjuTMeta } from "/opt/buildhome/repo/pages/index.vue?macro=true";
import { default as indexvgP5cq38rwMeta } from "/opt/buildhome/repo/pages/l/[slug]/index.vue?macro=true";
import { default as portal9ZGR1QTwxjMeta } from "/opt/buildhome/repo/pages/public/[customerId]/portal.vue?macro=true";
import { default as indexUhtrFf4tLfMeta } from "/opt/buildhome/repo/pages/scanner/index.vue?macro=true";
import { default as indexGjvb4dkXLuMeta } from "/opt/buildhome/repo/pages/settings/index.vue?macro=true";
import { default as customersWi4rYA9CoHMeta } from "/opt/buildhome/repo/pages/subscription-plans/[planId]/customers.vue?macro=true";
import { default as indexU5It7995AbMeta } from "/opt/buildhome/repo/pages/subscription-plans/[planId]/index.vue?macro=true";
import { default as createjC0ujBKENlMeta } from "/opt/buildhome/repo/pages/subscription-plans/create.vue?macro=true";
import { default as indexvabvhLPzl0Meta } from "/opt/buildhome/repo/pages/subscription-plans/index.vue?macro=true";
export default [
  {
    name: "admin",
    path: "/admin",
    meta: indexhyMXUmjJA7Meta || {},
    component: () => import("/opt/buildhome/repo/pages/admin/index.vue")
  },
  {
    name: "admin-merchants-id-users",
    path: "/admin/merchants/:id()/users",
    meta: usersHTuVCXEMNSMeta || {},
    component: () => import("/opt/buildhome/repo/pages/admin/merchants/[id]/users.vue")
  },
  {
    name: "admin-merchants-id-website",
    path: "/admin/merchants/:id()/website",
    meta: websiteKozLM7DwZVMeta || {},
    component: () => import("/opt/buildhome/repo/pages/admin/merchants/[id]/website.vue")
  },
  {
    name: "admin-settings",
    path: "/admin/settings",
    meta: settingsL7gywDGAzZMeta || {},
    component: () => import("/opt/buildhome/repo/pages/admin/settings.vue")
  },
  {
    name: "customers-id",
    path: "/customers/:id()",
    component: () => import("/opt/buildhome/repo/pages/customers/[id].vue")
  },
  {
    name: "customers",
    path: "/customers",
    component: () => import("/opt/buildhome/repo/pages/customers/index.vue")
  },
  {
    name: "dashboard",
    path: "/dashboard",
    component: () => import("/opt/buildhome/repo/pages/dashboard/index.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/opt/buildhome/repo/pages/index.vue")
  },
  {
    name: "l-slug",
    path: "/l/:slug()",
    meta: indexvgP5cq38rwMeta || {},
    component: () => import("/opt/buildhome/repo/pages/l/[slug]/index.vue")
  },
  {
    name: "public-customerId-portal",
    path: "/public/:customerId()/portal",
    meta: portal9ZGR1QTwxjMeta || {},
    component: () => import("/opt/buildhome/repo/pages/public/[customerId]/portal.vue")
  },
  {
    name: "scanner",
    path: "/scanner",
    component: () => import("/opt/buildhome/repo/pages/scanner/index.vue")
  },
  {
    name: "settings",
    path: "/settings",
    component: () => import("/opt/buildhome/repo/pages/settings/index.vue")
  },
  {
    name: "subscription-plans-planId-customers",
    path: "/subscription-plans/:planId()/customers",
    component: () => import("/opt/buildhome/repo/pages/subscription-plans/[planId]/customers.vue")
  },
  {
    name: "subscription-plans-planId",
    path: "/subscription-plans/:planId()",
    component: () => import("/opt/buildhome/repo/pages/subscription-plans/[planId]/index.vue")
  },
  {
    name: "subscription-plans-create",
    path: "/subscription-plans/create",
    component: () => import("/opt/buildhome/repo/pages/subscription-plans/create.vue")
  },
  {
    name: "subscription-plans",
    path: "/subscription-plans",
    component: () => import("/opt/buildhome/repo/pages/subscription-plans/index.vue")
  }
]